export const isPdf = (router) => {
  if (router?.pathname?.includes('/pdf')) return true
  return false
}
